<template>
	<el-main>
		<!-- 把整体看作一个table -->
		<el-col class="el-col">
			<!-- 头部区域 -->
			<div class="colhead">
				<el-form>
					<h2 class="header_h2">体检人员名单</h2>
					<el-form-item label="审核备注:">
						<el-input v-model="txtApproveMemo" placeholder="请输入审核备注信息"></el-input>
					</el-form-item>
				</el-form>

			</div>
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="MyData.slice((currentPage-1)*pagesize,currentPage*pagesize)">

				<el-table-column prop="FileTitle" label="名单标题" width="100%"></el-table-column>
				<el-table-column prop="PFileState" label="名单状态">
					<template slot-scope="scope">
						<label v-if="scope.row.PFileState=='0'">新增名单</label>
						<label v-if="scope.row.PFileState=='1'">名单已导入系统</label>
						<label v-if="scope.row.PFileState=='2'">名单有误</label>
						<label v-if="scope.row.PFileState=='3'">名单已修复</label>

					</template>
				</el-table-column>
				<el-table-column prop="FileMemo" label="备注"></el-table-column>
				<el-table-column prop="SalerName" label="业务员"></el-table-column>
				<el-table-column prop="UploadDate" label="提交时间" width="120px"></el-table-column>
				<el-table-column prop="ApproveName" label="审核人"></el-table-column>
				<el-table-column prop="ApproveDate" label="审核时间" width="120px"></el-table-column>
				<el-table-column prop="ApproveMemo" label="审核备注"></el-table-column>
				<el-table-column label="操作" width="200px" fixed="right">
					<template slot-scope="scope">
						<el-popover :content="fileUrl" placement="top-start" title="路径" width="200" trigger="hover">
							<a slot="reference" :href="fileUrl" class="el-link--primary" style="word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color: #1890ff;font-size: 13px;"
							 target="_blank" @click="btnDown(scope.$index,scope.row)">
								下载
							</a>
						</el-popover>
						<!-- <el-button @click="btnDown(scope.$index,scope.row)" icon="el-icon-bottom" type="text" size="small">下载</el-button> -->
						<el-button @click="btnInputed(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">已导入系统</el-button>
						<el-button @click="btnInErr(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">名单有误</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="MyData.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-col>
	</el-main>
</template>



<script>
	import store from '../../store/index.js'
	import CommonFun from '../../commontools/CommonFun.js'
	import OrderPerson from '../../apifunction/OrderPerson.js'
	export default {
		created: function() {
			
			this.Init();
			this.mytoken="Bearer " + store.state.token
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "Init"
		},
		data() {
			return {
				MyData: [],
				currentPage: 1,
				pagesize: 10,
				txtApproveMemo: '',
				fileUrl: '',
				orderEnt:null,
				mytoken:''
			};
		},
		methods: {
			//   得到所有的数据---------------
			Init() {
				var ent = this.$route.query.ent;
				this.orderEnt = JSON.parse(ent);
				OrderPerson.GetOrderPersonByOrder(this.orderEnt.OrderID)
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							// alert(JSON.stringify(ent.Data))
							this.MyData = JSON.parse(JSON.stringify(ent.Data));
						} else
							this.$message.info(ent.Msg);
					})
				// this.CorpData = enums.CorpData;
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			btnDown: function(index, item) {
				//  
				this.fileUrl =OrderPerson.DawnSingle(item.PID)
				// .then(res => {
				// 	if (res) {
				// 		//console.log(JSON.stringify(res))

				// 		let fileName = item.FilePath.substring(item.FilePath.lastIndexOf("\\")+1);
				// 		//alert(JSON.stringify(res))
				// 		const blob = new Blob([res.data]);// ,{type:'application/octet-stream'});
				// 		 if ("download" in document.createElement("a")) {//type:'application/octet-stream'
				// 		          // 非IE下载
				// 		          var elink = document.createElement("a");
				// 		          elink.download = fileName;
				// 		          elink.style.display = "none";
				// 		          elink.href = URL.createObjectURL(blob);
				// 		          document.body.appendChild(elink);
				// 		          elink.click();
				// 		          URL.revokeObjectURL(elink.href); // 释放URL 对象
				// 		          document.body.removeChild(elink);
				// 		        } else {
				// 		          // IE10+下载
				// 		          navigator.msSaveBlob(blob, fileName);
				// 		        }
				// 	}
				// })
			},
			btnInputed: function(index, item) {
				this.Approve('1', item);
			},
			btnInErr: function(index, item) {
				this.Approve('2', item);
			},
			Approve: function(state, item) {
				//let user = JSON.parse(JSON.stringify(this.myglobal.userinfo))
				var entord = JSON.parse(JSON.stringify(item))
				entord.ApproveID = this.$myglobal.getUserInfo().id;
				entord.ApproveName = this.$myglobal.getUserInfo().username;
				entord.ApproveDate = CommonFun.GetNowDateTime();
				entord.ApproveMemo = this.txtApproveMemo;
				entord.PFileState = state;
				OrderPerson.ApproveOrderPerson(entord)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');
							item.ApproveID = entord.ApproveID;
							item.ApproveName = entord.ApproveName;
							item.ApproveDate = entord.ApproveDate;
							item.ApproveMemo = entord.ApproveMemo;
							item.PFileState = entord.PFileState;
						} else
							this.$message.info(ent.Msg);
					})
			}
		}

	}
</script>


<style scoped>
	.colhead {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.header_h2 {
		color: #333;
		background-color: #f5f5f5;
		border-color: #ddd;
		font-size: 20px;
		text-align: left;
		line-height: 1.7;
		text-align: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
	}
</style>
